import React, { useState } from 'react';
import axios from 'axios'
import { backendUrl } from '../App';
import { toast } from 'react-toastify';

const Login = ({setToken}) => {
  const [email, setemail] = useState("");
  const [password, setpassword] = useState("");

  const handleSubmit = async (e) => {
    try {
      e.preventDefault();
      
      const response = await axios.post(backendUrl + '/api/user/admin',{email,password})
      if(response.data.success){
        setToken(response.data.token);
      }
      else{
        toast.error(response.data.message);
      }
      
    } catch (error) {
      console.error(error);
      toast.error(error.message);
    }   
  };

  return (
    <div className="d-flex align-items-center justify-content-center vh-100">
      <div className="card p-4 shadow-lg" style={{ width: '350px' }}>
        <h2 className="text-center mb-4 text-secondary fw-bold">Admin</h2>
        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <input
              type="email"
              className="form-control"
              placeholder="Email"
              value={email}
              onChange={(e) => setemail(e.target.value)}
              required
            />
          </div>
          <div className="mb-3">
            <input
              type="password"
              className="form-control"
              placeholder="Password"
              value={password}
              onChange={(e) => setpassword(e.target.value)}
              required
            />
          </div>
          <button className="btn w-100" type="submit" style={{ backgroundColor: 'black', color: 'white' }}>
            Login
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
